var map = {
	"./app-store-badge_en.png": [
		91347,
		347
	],
	"./app-store-badge_jp.png": [
		21820,
		820
	],
	"./app-store-badge_pt.png": [
		64746,
		746
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 94685;
module.exports = webpackAsyncContext;